// File/photo upload helper (Firebase Storage, JS SDK — works on web + native).
//
// SCAFFOLDING: wired up and ready, but gated behind PHOTO_UPLOADS_ENABLED so no
// upload UI shows yet. To turn on later:
//   1. Enable the Storage bucket in the Firebase console (one-time).
//   2. Deploy storage.rules.
//   3. Add a picker (expo-image-picker / a web <input type=file>) — the picker
//      is the only native piece and needs a new build.
//   4. Flip PHOTO_UPLOADS_ENABLED to true (OTA-able once the build ships).
//
// The upload itself uses the JS SDK (no native module), so this file is safe to
// ship now; storage is lazily initialized so nothing touches the bucket unless
// a function here is actually called.

export const PHOTO_UPLOADS_ENABLED = true;

let _storage = null;
const getStorageLazy = () => {
  if (_storage) return _storage;
  const { getStorage } = require('firebase/storage');
  const app = require('./config').default;
  _storage = getStorage(app);
  return _storage;
};

// Upload a local file (a picker URI string, or a web File/Blob) and return its
// public download URL. `storagePath` e.g. `incidents/<incidentId>/<filename>`.
export const uploadFileAsync = async (storagePath, fileOrUri) => {
  const { ref, uploadBytes, getDownloadURL } = require('firebase/storage');
  const storage = getStorageLazy();
  let blob = fileOrUri;
  if (typeof fileOrUri === 'string') {
    const res = await fetch(fileOrUri);
    blob = await res.blob();
  }
  const r = ref(storage, storagePath);
  await uploadBytes(r, blob);
  return getDownloadURL(r);
};

// Delete a stored file by its gs:// or https download URL.
export const deleteFileByUrl = async (url) => {
  try {
    const { ref, deleteObject } = require('firebase/storage');
    await deleteObject(ref(getStorageLazy(), url));
  } catch {
    // Already gone / not a storage URL — nothing to do.
  }
};
